import React from "react";
import { Link } from "react-router-dom";
import { PILLARS, PORTRAITS } from "@/data/content";

export const PhilosophyPreview = () => {
  return (
    <section data-testid="home-philosophy-preview" className="bg-ink-base py-24 md:py-36 border-t border-ink-line">
      <div className="container-edge">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {/* Image / portrait */}
          <div className="lg:col-span-5">
            <div className="aspect-[4/5] overflow-hidden border border-ink-line bg-ink-surface">
              <img
                src={PORTRAITS.seatedThinker}
                alt="Quentin Young, seated in golden-hour light, hand near his temple in a thinking pose."
                className="w-full h-full object-cover img-desaturate"
                loading="lazy"
              />
            </div>
            <div className="mt-4 flex items-start justify-between gap-3">
              <p className="eyebrow">Portrait No. 02, Thinker</p>
              <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-paper-mute">QY · 2026</p>
            </div>
          </div>

          {/* Pillars */}
          <div className="lg:col-span-7">
            <p className="eyebrow-gold mb-5">Philosophy · Six Pillars</p>
            <h2 className="display-serif text-3xl md:text-5xl text-paper-primary text-balance">
              Six lenses. One way of seeing.
            </h2>
            <p className="mt-6 max-w-xl font-serif text-lg md:text-xl text-paper-secondary leading-relaxed text-pretty">
              Architect, Builder, Observer, Steward, Catalyst, Compass. Each lens rewards a discipline.
              Each lens rejects a familiar failure.
            </p>

            <ul className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-8">
              {PILLARS.map((p) => (
                <li key={p.name} className="group">
                  <div className="flex items-baseline gap-4 border-b border-ink-line pb-4">
                    <span className="font-mono text-[10px] tracking-[0.24em] text-paper-mute">{p.number}</span>
                    <h3 className="font-serif text-2xl text-paper-primary group-hover:text-gold-warm transition-colors duration-300">
                      {p.name}
                    </h3>
                  </div>
                  <p className="mt-3 text-paper-tertiary text-sm leading-relaxed">{p.definition}</p>
                </li>
              ))}
            </ul>

            <Link to="/philosophy" className="btn-arrow mt-12 inline-flex" data-testid="philosophy-preview-cta">
              <span>Study the framework</span>
              <span className="arrow">→</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhilosophyPreview;
